"use client";

import * as config from "@/app/config";
import { usePathname } from "next/navigation";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { type PropsWithChildren, useLayoutEffect } from "react";
import {
  isSessionRecordingPath,
  sessionRecordingOptions,
  useSessionRecordingRequested,
} from "./posthog-session-recording";

if (typeof window !== "undefined" && config.POSTHOG_ENABLED) {
  posthog.init(config.POSTHOG_API_KEY, {
    api_host: config.POSTHOG_HOST,
    person_profiles: "identified_only",
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: true,
    ...sessionRecordingOptions,
  });
}

function SessionRecordingSwitch() {
  const pathname = usePathname();
  const requested = useSessionRecordingRequested();
  const shouldRecord = isSessionRecordingPath(pathname) || requested;
  // 遷移先の DOM の変化を rrweb が受け取る前に止めるため、描画と同じタスクで切り替える。
  useLayoutEffect(() => {
    if (shouldRecord) {
      posthog.startSessionRecording();
    } else {
      posthog.stopSessionRecording();
    }
  }, [shouldRecord]);
  return null;
}

export function PostHogProviderWrapper({ children }: PropsWithChildren) {
  if (!config.POSTHOG_ENABLED) return <>{children}</>;
  return (
    <PostHogProvider client={posthog}>
      <SessionRecordingSwitch />
      {children}
    </PostHogProvider>
  );
}
